"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestTargetsResponseToJSON = exports.InterestTargetsResponseFromJSONTyped = exports.InterestTargetsResponseFromJSON = exports.instanceOfInterestTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var InterestWithSubtargets_1 = require("./InterestWithSubtargets");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the InterestTargetsResponse interface.
 */
function instanceOfInterestTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfInterestTargetsResponse = instanceOfInterestTargetsResponse;
function InterestTargetsResponseFromJSON(json) {
    return InterestTargetsResponseFromJSONTyped(json, false);
}
exports.InterestTargetsResponseFromJSON = InterestTargetsResponseFromJSON;
function InterestTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'interests': !(0, runtime_1.exists)(json, 'interests') ? undefined : (json['interests'].map(TargetBase_1.TargetBaseFromJSON)),
        'interestsWithSubtargets': !(0, runtime_1.exists)(json, 'interests_with_subtargets') ? undefined : (json['interests_with_subtargets'].map(InterestWithSubtargets_1.InterestWithSubtargetsFromJSON)),
    };
}
exports.InterestTargetsResponseFromJSONTyped = InterestTargetsResponseFromJSONTyped;
function InterestTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'interests': value.interests === undefined ? undefined : (value.interests.map(TargetBase_1.TargetBaseToJSON)),
        'interests_with_subtargets': value.interestsWithSubtargets === undefined ? undefined : (value.interestsWithSubtargets.map(InterestWithSubtargets_1.InterestWithSubtargetsToJSON)),
    };
}
exports.InterestTargetsResponseToJSON = InterestTargetsResponseToJSON;
